module.exports = __webpack_public_path__ + "static/img/contant_6.83a1e16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_5/contant_6.png
// module id = ncaZ
// module chunks = 0